import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import {
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/trackers-list/constants';
import {
  ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_MAIN_ROUTE_NAME,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/trackers-list/submodules/fixed-tracker-payments/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_HISTORY_EDIT_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATES_TRACKERS_FIXED_PAYMENTS_HISTORY_EDIT,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedFixedPaymentsHistoryChangesEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_MAIN_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_TRACKERS_FIXED_PAYMENTS_HISTORY_EDIT_ROUTE_NAME,
      path: ':merchantId/history/:itemId',
      permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.HISTORY_CHANGES_EDIT,
      component: () => import('./pages/FixedPaymentsHistoryEditPage/FixedPaymentsHistoryEditPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATES_TRACKERS_FIXED_PAYMENTS_HISTORY_EDIT, getTranslationKeys);
  }
}
